'use strict';

var isDocumentDefined = typeof document !== 'undefined',
	isWireless = isDocumentDefined ? document.body.getAttribute('data-iswireless') === 'true' : false,
	isTablet = isDocumentDefined ? document.body.getAttribute('data-istablet') === 'true' : false,
	isSmartphone = isWireless && !isTablet,
	input = isDocumentDefined ? document.createElement('input') : null,
	hasClearButton = input ? window.getComputedStyle && window.getComputedStyle(input, ':-ms-clear').content : false,
	canShowClearInput = isWireless && !hasClearButton;

module.exports = {
	isWireless: isWireless,
	isTablet: isTablet,
	isSmartphone: isSmartphone,
	canShowClearInput: canShowClearInput
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/browser-wurfl/index.js
// module id = 534
// module chunks = 3